import { ControlledInput } from '../form-controls';
import { useForm } from 'react-hook-form';
import '../../pages/login/login-page.css';

export type TOTPFormFields = {
  code: number;
};

interface TOTPFormProps {
  onSubmit: (data: TOTPFormFields) => void;
  error?: string; // Optional error property
}

export const TOTPForm: React.FC<TOTPFormProps> = ({ onSubmit, error }) => {
  const { handleSubmit, control } = useForm<TOTPFormFields>({});

  return (
    <form className="login-form" onSubmit={handleSubmit(onSubmit)}>
      <ControlledInput
        control={control}
        name="code"
        rules={{ required: true }}
        inputProps={{
          placeholder: 'TOTP Code',
          className: 'input-form',
          fullWidth: true,
          autoFocus: true,
        }}
      />
      {error && (
        <p className="error-message" role="alert">
          {error}
        </p>
      )}
      <button className="login-submit" type="submit">
        Login
      </button>
    </form>
  );
};
